import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { services } from "./data";
import { ChevronRight } from "@mui/icons-material";
import { Block } from "../../../shared";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export function AdditionalServicesCard() {
  const theme = useTheme();
  const { t } = useTranslation("home");

  return (
    <Block>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: "500",
          textAlign: "center",
          marginBottom: "12px",
        }}
      >
        {t("additional_services.title")}
      </Typography>
      <List sx={{ padding: "0" }}>
        {services.map((service, index) => {
          const message = t(service.messageKey);
          const link = `https://t.me/${service.managerUsername ?? "zero_manager"}?text=${encodeURIComponent(message)}`;
          return (
            <ListItem
              onClick={() =>
                !service.soon
                  ? Telegram.WebApp.openTelegramLink(link)
                  : enqueueSnackbar(t("additional_services.coming_soon_toast"), {
                      variant: "warning",
                    })
              }
              key={index}
              sx={{
                cursor: "pointer",
                paddingInline: 0,
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <ListItemIcon
                  sx={{
                    backgroundColor: "secondary.light",
                    minWidth: "32px",
                    minHeight: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    marginRight: "10px",
                  }}
                >
                  {service.icon}
                </ListItemIcon>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  borderBottom:
                    index !== services.length - 1
                      ? `1px solid ${
                          theme.palette.mode === "dark"
                            ? "#26262A"
                            : "rgba(239, 239, 243, 1)"
                        }`
                      : "none",
                  paddingBottom: "8px",
                }}
              >
                <ListItemText
                  sx={{ margin: 0 }}
                  primary={<Typography>{t(service.titleKey)}</Typography>}
                  secondary={
                    service.descriptionKey ? (
                      <Typography sx={{ opacity: ".5", fontSize: "12px" }}>
                        {t(service.descriptionKey)}
                      </Typography>
                    ) : null
                  }
                />
                <ChevronRight sx={{ color: "#b0b0b0", marginLeft: "auto" }} />
              </Box>
            </ListItem>
          );
        })}
      </List>
    </Block>
  );
}
